import { NgxSpinnerService } from "ngx-spinner";
import { NgxIndexedDBService } from "ngx-indexed-db";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { ICSchedulation } from "../models/entities/icschedulation";
import { ICSchedulationFilter } from "../models/filters/icschedulation.filter";
import { ICSchedulationApi } from "../models/apis/icschedulation.api";
import { BaseDataService } from "./shared/base.data.service";

@Injectable()
export class ICSchedulationService extends BaseDataService<
  ICSchedulation,
  ICSchedulationFilter,
  ICSchedulationApi
> {
  constructor(
    public dbSrv: NgxIndexedDBService,
    public spinner: NgxSpinnerService,
    public http: HttpClient,
  ) {
    super(dbSrv, spinner, http, ICSchedulation);
    this.EndPoint = "icschedulation";
  }
}
